'use es6';

import PropTypes from 'prop-types';
import styled from 'styled-components';
import IframeToolbar from 'tinymce-themes/components/IframeToolbar';
import IframeFooter from 'tinymce-themes/components/IframeFooter';
import { getNamespace } from 'tinymce-themes/utils/namespace';
import { SHOW_TOOLBAR_SHEPHERD } from 'tinymce-themes/constants/toolbar';
import TinymceErrorBoundary from './TinymceErrorBoundary';
import Popovers from './Popovers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorContainer = styled.div.withConfig({
  displayName: "TinymceIframe__EditorContainer",
  componentId: "sc-1x92ld5-0"
})(({
  theme
}) => {
  return `
    border: ${theme.borderWidth['100']} solid ${theme.color['border-core-default']};
    position: relative;
    .tox-edit-area__iframe {
      height: 100%;
      width: 100%;
      display: block;
    }
  `;
});
const noop = () => {};
const TinymceIframe = ({
  initialized,
  editor,
  content,
  className,
  id,
  readOnly,
  hasToolbar = true,
  'data-onboarding': dataOnboarding,
  'data-test-id': dataTestId
}) => {
  const initWithToolbar = initialized && hasToolbar;

  // @bend-expect trellis-tokenized
  return /*#__PURE__*/_jsx(TinymceErrorBoundary, {
    children: /*#__PURE__*/_jsxs(EditorContainer, {
      role: "application",
      tabIndex: "-1",
      className: "tinymce-editor-container",
      "data-onboarding": dataOnboarding,
      "data-test-id": dataTestId,
      children: [initWithToolbar && /*#__PURE__*/_jsx(IframeToolbar, {
        disabled: readOnly,
        editor: editor,
        toolbar: editor.settings.canvasToolbar,
        showToolbarShepherd: editor.settings[SHOW_TOOLBAR_SHEPHERD],
        namespace: getNamespace(editor),
        shepherdClassName: "mce-shepherd"
      }),
      /*#__PURE__*/
      /* @bend-expect trellis-tokenized */
      _jsx("textarea", {
        id: id,
        className: className,
        style: {
          visibility: 'hidden'
        },
        value: content,
        onChange: noop
      }), initWithToolbar && editor.getParam('useDarkBackground') && /*#__PURE__*/_jsx(IframeFooter, {
        editor: editor
      }), initialized && /*#__PURE__*/_jsx(Popovers, {
        editor: editor
      })]
    })
  });
};
TinymceIframe.propTypes = {
  initialized: PropTypes.bool.isRequired,
  hasToolbar: PropTypes.bool,
  editor: PropTypes.object,
  content: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string,
  readOnly: PropTypes.bool,
  'data-onboarding': PropTypes.string,
  'data-test-id': PropTypes.string
};
export default TinymceIframe;